/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Showcase_SetInputs */



/**
* | output |
* | --- |
* | "Changed whether the server is listed publicly" |
*
* @param {Activity_Showcase_SetInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_showcase_set = /** @type {((inputs?: Activity_Showcase_SetInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Showcase_SetInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменена видимость сервера в публичном списке")
	return /** @type {LocalizedString} */ ("Changed whether the server is listed publicly")
});